import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const getNotifications = ({userId, values,dispatch, token,userRole,currentClinicId }) => {
    return ApiClient.post(`${API_URL}/notification/notifications?userId=${userId}&userRole=${userRole}&currentClinicId=${currentClinicId}`,values, token, dispatch);
};

export const markNotificationsAsRead = ({userId, type,dispatch,userRole,currentClinicId }) => {
    return ApiClient.put(`${API_URL}/notification/mark-notifications-read?userId=${userId}&type=${type}&userRole=${userRole}&currentClinicId=${currentClinicId}`, dispatch);
};

export const getNotificationCount = ({userId, type,dispatch,role,currentClinicId }) => {
    return ApiClient.get(`${API_URL}/notification/notification-count?userId=${userId}&userRole=${role}&currentClinicId=${currentClinicId}`, dispatch);
};
